/* eslint-disable react/prop-types */
import React from 'react';
import { ClipLoader } from 'react-spinners';
import FontAwesome from 'react-fontawesome';
import { _ab_color } from "../../style";
import SimpleButton from "../../core/button/SimpleButton";
import { _ChooseButton, _EditButton, _NoSelection, _NoteTitle, _PreviewTitle, _PreviewWrapper, _Renderer, _RendererButtonsWrapper, _RendererContainer, _Tags, _TemplateID } from "./styles";
import { Markdown } from '@applyboard/crystal-ui';

/**
 * @param props {object}
 * @param props.canCreateBulkNote {(permissions: Record<string, boolean> | false, noteType: 'admin' | 'customer') => boolean}

 */
var NoteTemplateRenderer = function NoteTemplateRenderer(_ref) {
  var chooseNoteTemplate = _ref.chooseNoteTemplate,
    error = _ref.error,
    handleTemplateIdForMultipleApplications = _ref.handleTemplateIdForMultipleApplications,
    isLegacyAdminTab = _ref.isLegacyAdminTab,
    is_loading = _ref.is_loading,
    permissions = _ref.permissions,
    rendered_template_body = _ref.rendered_template_body,
    template = _ref.template,
    trackEvent = _ref.trackEvent,
    canCreateBulkNote = _ref.canCreateBulkNote;
  return /*#__PURE__*/React.createElement(_Renderer, null, template ? /*#__PURE__*/React.createElement(_RendererContainer, null, /*#__PURE__*/React.createElement(_TemplateID, null, "Template ID: ", /*#__PURE__*/React.createElement("span", null, template.id)), /*#__PURE__*/React.createElement(_PreviewTitle, null, "Preview"), /*#__PURE__*/React.createElement(_Tags, null, template.email_user && permissions.edit_note_template && /*#__PURE__*/React.createElement("span", null, "Email Recruitment Partner"), template.restricted && /*#__PURE__*/React.createElement("span", null, "Private Note")), /*#__PURE__*/React.createElement(_NoteTitle, null, /*#__PURE__*/React.createElement("strong", null, "Title:"), /*#__PURE__*/React.createElement("span", null, template.note_title || '')), /*#__PURE__*/React.createElement(_PreviewWrapper, null, is_loading ? /*#__PURE__*/React.createElement(ClipLoader, {
    color: _ab_color.blue,
    size: 30
  }) : /*#__PURE__*/React.createElement(Markdown, {
    markdown: rendered_template_body !== null && rendered_template_body !== void 0 ? rendered_template_body : '',
    headingSettings: {
      baseLevel: 3,
      styles: {
        h1: {
          variant: 'bodyM',
          contrast: 'mid',
          bold: true
        }
      }
    }
  })), !is_loading && /*#__PURE__*/React.createElement(_RendererButtonsWrapper, null, /*#__PURE__*/React.createElement(_ChooseButton, null, /*#__PURE__*/React.createElement(SimpleButton, {
    onClick: chooseNoteTemplate,
    disabled: error
  }, "Choose")), permissions.edit_note_template && /*#__PURE__*/React.createElement("a", {
    href: "/notes/templates?template_id=".concat(template.id),
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(_EditButton, null, /*#__PURE__*/React.createElement(SimpleButton, {
    disabled: error
  }, "Edit Template", /*#__PURE__*/React.createElement(FontAwesome, {
    name: "external-link"
  })))), canCreateBulkNote(permissions, isLegacyAdminTab ? 'admin' : 'customer') && /*#__PURE__*/React.createElement(_EditButton, null, /*#__PURE__*/React.createElement(SimpleButton, {
    onClick: function onClick() {
      trackEvent && trackEvent({
        event: "Single Application - ".concat(isLegacyAdminTab ? 'Admin Comments' : 'Notes', " - Started Batch Note"),
        data: {
          templateId: template === null || template === void 0 ? void 0 : template.id
        }
      });
      handleTemplateIdForMultipleApplications();
    }
  }, "Batch Send")))) : /*#__PURE__*/React.createElement(_NoSelection, null, "Select a template..."));
};
export default NoteTemplateRenderer;